import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ModalController } from 'ionic-angular';
import { Http } from '@angular/http';
import { Payment } from '../../../pages/event-catalogs-payment/payment/payment';
import { Database } from '../../../providers/database';
import { EventData } from '../../../providers/event';
import { Translate } from '../../../providers/translate';
import { AuthData } from '../../../providers/auth';
import { GlobalConfig } from '../../../app/app.config';
import * as CryptoJS from '../../../../node_modules/crypto-js/crypto-js.js';
import * as firebase from 'firebase';

@Component({
  selector: 'paymentez',
  templateUrl: 'paymentez.html'
})
export class Paymentez {

  obs: any;
  client: any;
  dataCart: any;
  total: any;
  event: any;
  paymentConfig: any;
  paymentData: any;
  textTranslate: any;

  constructor(public params: NavParams, public db: Database, public auth: AuthData, public alertCtrl: AlertController, translate: Translate, public eventProvider: EventData, public loadingCtrl: LoadingController, public navCtrl: NavController, public modalCtrl: ModalController) {
    translate.translateGroup(['¿Está seguro que desea continuar con el proceso de pago?', 'Cancelar', 'Continuar', 'Compra+No'])
    .then(result => {
      this.textTranslate = result;
    });

    this.client = this.params.get('client');
    this.event = this.params.get('event');

    let flag = false;
    this.obs = this.eventProvider.getCatalogBadge(this.client, this.auth.getUser().uid).subscribe((data) => {
      if (!flag) {
        this.dataCart = data;
        this.total = 0;
        this.dataCart.forEach((element: any) => {
          this.total += parseInt(element.price) * parseInt(element.quantity);
        });
        flag = true;
      }
    });

    if (this.event.paymentMethod) {
      this.db.getData('/Clients/' + this.client.url + '/PaymentMethods/' + this.event.paymentMethod)
      .then((result: any) => {
        this.paymentConfig = result.val();
      });
    }
  }

  pay() {
    let alert = this.alertCtrl.create({
      title: this.event.title,
      message: this.textTranslate['¿Está seguro que desea continuar con el proceso de pago?'],
      buttons: [
        {
          text: this.textTranslate['Cancelar'],
          role: 'cancel',
          handler: data => {}
        },
        {
          text: this.textTranslate['Continuar'],
          handler: data => {
            let loader = this.loadingCtrl.create({
              dismissOnPageChange: true
            });
            loader.present();
            let tmp2 = [];
            let packagePay: any = {
              products: '',
              info: {
                timestamp: new Date().getTime(),
                state: 'initialized'
              }
            };
            this.dataCart.forEach((element: any) => {
              let tmp = element;
              delete(tmp['$exists']);
              delete(tmp['$key']);
              tmp2.push(element);
            });
            packagePay.products = tmp2;

            this.db.pushData('/Clients/' + this.client.url + '/___PayUsers/' + this.auth.getUser().uid, packagePay)
            .then(resultId => {

              this.dataCart.forEach((element: any) => {
                // Delete cart and dismiss counter user
                this.db.deleteData('/Clients/' + this.client.url + '/___CartUsers/' + this.auth.getUser().uid + '/' + element.id).then(() => {
                    firebase.database().ref().child('/Clients/' + this.client.url + '/Users/' + this.auth.getUser().uid + '/numCartPending').
                    transaction(function(currentCount) {
                      if (currentCount > 0) {
                        return currentCount - 1;
                      } else {
                        return 0;
                      }
                    });
                });
              });

              let timeData = new Date().getTime();
              let plain_text = "application_code=" + this.paymentConfig.application_code + "&dev_reference=" + resultId + "&product_amount=" + this.total + ".00" + "&product_code=" + resultId + "&product_description=" + this.textTranslate['Compra+No'] + "+" + resultId + "&uid=" + this.auth.getUser().uid + "&" + timeData + "&" + this.paymentConfig.application_key;
              var hashed = CryptoJS.SHA256(plain_text);
              let auth_token = hashed.toString(CryptoJS.Base64)

              let modal = this.modalCtrl.create(Payment, {client: this.client, event: this.event, dataPay: packagePay});
              modal.present();
              this.navCtrl.pop();

              window.open(
                "https://ccapi-stg.paymentez.com/api/cc/pay/?application_code=" + this.paymentConfig.application_code + "&uid=" + this.auth.getUser().uid + "&auth_timestamp=" + timeData + "&auth_token=" + auth_token + "&dev_reference=" + resultId + "&product_description=" + this.textTranslate['Compra+No'] + "+" + resultId + "&product_code=" + resultId + "&product_amount=" + this.total + ".00" + "&success_url=https://davivienda.rebus.com.co&failure_url=https://davivienda.rebus.com.co&review_url=https://davivienda.rebus.com.co",
                // "https://ccapi-stg.paymentez.com/api/cc/pay/?application_code=" + this.paymentConfig.application_code + "&uid=" + this.auth.getUser().uid + "&auth_timestamp=" + timeData + "&auth_token=" + auth_token + "&dev_reference=" + resultId + "&product_description=" + this.textTranslate['Compra+No'] + "+" + resultId + "&product_code=" + resultId + "&product_amount=" + this.total + ".00" + "&success_url=" + GlobalConfig._domain + "/#/app/" + this.client.url + "/securePayment/" + resultId + "/" + this.auth.getUser().uid + "&failure_url=https://davivienda.rebus.com.co&review_url=https://davivienda.rebus.com.co",
                // '_self'
                '_blank'
              );
            });
          }
        }
      ]
    });
    alert.present();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/payment-methods/paymentez/paymentez.ts